import { FC, createElement } from 'react';

import { Image as RebassImage } from '../Rebass';
import { BoxProps } from '../Rebass/types';

interface ImageProps extends BoxProps {
  src: string;
  alt: string;
  component?: string;
  children?: React.ReactNode;
}

const imageComponents = {
  rebass: RebassImage,
};

const Image: FC<ImageProps> = ({
  src,
  alt,
  component = 'rebass',
  children,
  ...props
}) =>
  createElement(imageComponents[component], { ...props, src, alt }, children);

export default Image;
